import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { Events, useTracking } from 'services';
import { Address } from 'types';
import { useQual, useStore } from 'hooks';

export function useAcceptUpdaterTerms() {
  const tracker = useTracking();
  const { street, unit, city, state, zip, userFirstName, userLastName } =
    useQual();
  const [setAcceptedUpdaterTerms] = useStore(
    useShallow((store) => [store.setAcceptedUpdaterTerms])
  );

  return useCallback(
    (addressOverride?: Address) => {
      // Address type uses postalCode; Qual type uses zip.
      // Translated here so callers can pass either a fresher Address they
      // already have on hand, or nothing to fall back to useQual's.
      const userAddress = addressOverride
        ? {
            street: addressOverride.street,
            unit: addressOverride.unit,
            city: addressOverride.city,
            state: addressOverride.state,
            zip: addressOverride.postalCode, // event payload expects zip
          }
        : { street, unit, city, state, zip };

      setAcceptedUpdaterTerms(true);
      tracker.trackEvent(Events.PRIVACY_AND_TERMS_CONSENT, 'accepted', {
        user_address: userAddress,
        first_name: userFirstName,
        last_name: userLastName,
      });
    },
    [
      tracker,
      street,
      unit,
      city,
      state,
      zip,
      userFirstName,
      userLastName,
      setAcceptedUpdaterTerms,
    ]
  );
}
